<template>
  <div id="card-abstract" class="row position-relative px-n3">
    <img
      :src="cardType == 'personal' ? AbstractLeftImage : AbstractRightImage"
      alt="abstract-background"
      class="abstract-image"
    />
    <div
      :key="list.id"
      v-for="list in cardList"
      class="col-12 col-lg-6 p-2 my-3 my-md-0"
    >
      <div class="card-abstract-item-wrapper">
        <!-- Ribbon Banner (Coming Soon) -->
        <div v-if="list.comingSoon || list.label === 'Modal Usaha' || list.label === 'Pengembangan Bisnis'" class="ribbon-wrapper">
          <div class="ribbon-text">Segera Hadir</div>
        </div>
        <div class="card-abstract-glow"></div>
        <div class="card-abstract-item-inner">
          <div class="abstract-icon-wrapper">
            <img :src="list.icon" :alt="list.label" class="abstract-icon" />
          </div>
          <span class="abstract-label">{{ list.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { efundingProsCardList } from "../../utils/efunding-pros-card-list.js";
import AbstractLeftImage from "../../assets/images/landing_page/img-abstract-left.png";
import AbstractRightImage from "../../assets/images/landing_page/img-abstract-right.png";

export default {
  name: "CardAbstract",
  data() {
    return {
      AbstractLeftImage,
      AbstractRightImage,
    };
  },
  props: {
    cardType: String,
  },
  computed: {
    cardList() {
      return efundingProsCardList[this.cardType] || [];
    },
  },
};
</script>

<style scoped>
.abstract-image {
  position: absolute;
  top: 5px;
  left: 5px;
  pointer-events: none;
  opacity: 0.15;
  z-index: 0;
}

#card-abstract {
  background-color: rgba(19, 52, 108, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 40px 20px;
  border-radius: 24px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Card Abstract Item Wrapper */
.card-abstract-item-wrapper {
  position: relative;
  background-color: rgba(13, 43, 94, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 24px 20px;
  height: 100%;
  cursor: default;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* Ribbon Container for Segera Hadir */
.ribbon-wrapper {
  width: 75px;
  height: 75px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}

/* Diagonal Ribbon Text */
.ribbon-text {
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 8px;
  font-weight: 700;
  color: #13346c;
  background-color: #f7bd3a;
  text-transform: uppercase;
  padding: 3px 0;
  position: relative;
  left: -10px;
  top: 14px;
  width: 110px;
  transform: rotate(45deg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.card-abstract-item-wrapper:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
  border-color: #f7bd3a;
  background-color: rgba(13, 43, 94, 0.8);
}

.card-abstract-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(247, 189, 58, 0.15) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
}

.card-abstract-item-wrapper:hover .card-abstract-glow {
  opacity: 1;
}

@keyframes float-slow-y {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

.card-abstract-item-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  animation: float-slow-y 5s ease-in-out infinite;
}

.col-12:nth-child(even) .card-abstract-item-inner {
  animation-delay: 2s;
}
.col-12:nth-child(odd) .card-abstract-item-inner {
  animation-delay: 0s;
}

.abstract-icon-wrapper {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.card-abstract-item-wrapper:hover .abstract-icon-wrapper {
  background: rgba(247, 189, 58, 0.12);
  border-color: rgba(247, 189, 58, 0.3);
  transform: scale(1.12) rotate(6deg);
}

.abstract-icon {
  width: 32px;
  height: auto;
  transition: all 0.4s ease;
}

.abstract-label {
  color: #e2e8f0;
  font-weight: 600;
  font-size: 15px;
  transition: color 0.3s ease;
}

.card-abstract-item-wrapper:hover .abstract-label {
  color: #f7bd3a;
}

/* Responsive styles */
@media (max-width: 991px) {
  #card-abstract {
    padding: 24px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardAbstract.vue